import controller from './contact-detail.controller';
import templateBase from './templates/contact-detail.view.html';
import templateAD from './templates/contact-detail-adaptative.html';

let ContactDetailComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

//changeTemplate.$inject = ['SessionService'];

function changeTemplate() {
    /*let response = SessionService.get('components');
    if (response.CONTACT.component == 'template_t1') {
        return templateT1;
    } else {*/
    //}
    if(__env.adaptative){
      return templateAD;
    }else{
      return templateBase;
    }
}

export default ContactDetailComponent



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/contact-detail/contact-detail.component.js
 **/